(function ($) {
  if (window.__haloSlideshowInitialized) return;
  window.__haloSlideshowInitialized = true;

  var halo = {
      // root lets the theme editor re-init just the section it re-rendered;
      // sliders that are already running are skipped so slick never runs twice.
      initSlideshow: function (root) {
            var slickSlideshow = $(root || document).find('[data-init-slideshow]').not('.slick-initialized');
            if (slickSlideshow.length) {
                slickSlideshow.each(function () {
                    var self = $(this),
                        auto_playvideo = self.data('auto-video');

                    if (self.find('.item-video').length) {
                      var tag = document.createElement('script');
                      tag.src = "https://www.youtube.com/iframe_api";
                      var firstScriptTag = document.getElementsByTagName('script')[0];
                      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
                    }

                    if(auto_playvideo) {
                        // POST commands to YouTube or Vimeo API
                        function postMessageToPlayer(player, command) {
                            if (player == null || command == null) return;
                            player.contentWindow.postMessage(JSON.stringify(command), "*");
                        }

                        // When the slide is changing
                        function playPauseVideo(slick, control) {
                            var currentSlide, player, video;

                            currentSlide = slick.find('.slick-current .item ');
                            // Prefer the desktop/mobile specific iframe (hero-showcase with a
                            // mobile video) and fall back to the plain iframe used by slide-show.
                            if($(window).width() > 551) {
                              player = currentSlide.find("iframe.slide-pc").get(0) || currentSlide.find("iframe").not(".slide-mobile").get(0);
                            } else {
                              player = currentSlide.find("iframe.slide-mobile").get(0) || currentSlide.find("iframe").get(0);
                            }

                            if (currentSlide.hasClass('slide-youtube')) {
                              var $frame;
                              if($(window).width() > 551) {
                                $frame = currentSlide.find('iframe.slide-pc');
                                if(!$frame.length) $frame = currentSlide.find('iframe').not('.slide-mobile');
                              } else {
                                $frame = currentSlide.find('iframe.slide-mobile');
                                if(!$frame.length) $frame = currentSlide.find('iframe');
                              }
                              var id = $frame.attr('id');
                              var video_id = $frame.data('video-id');
  
                               if (control === "play"){
                                    postMessageToPlayer(player, {
                                     "event": "command",
                                     "func": "playVideo"
                                   });
                                  self.slick('slickPause');
                                   $(player).on('ended', function() {
                                     postMessageToPlayer(player, {
                                       "event": "command",
                                       "func": "playVideo"
                                     });
                                     self.slick('slickPlay');
                                     self.slick('next');
                                   });
                                }
                               else {
                                  postMessageToPlayer(player, {
                                     "event": "command",
                                     "func": "pauseVideo"
                                   });
                               }
                               
                               var player1;
                               function onPlayerReady(event) {
                                 event.target.playVideo();
                               }

                                // when video ends
                               function onPlayerStateChange(event) { 
                                 if(event.data === 0) {
                                    postMessageToPlayer(player, {
                                       "event": "command",
                                       "func": "playVideo"
                                    });            
                                   self.slick('slickPlay');
                                   self.slick('next');
                                 }
                               }
                               function onYouTubePlayerAPIReady() {
                                    player1 = new YT.Player(id, {
                                      videoId: video_id,
                                      events: {
                                        'onReady': onPlayerReady,
                                        'onStateChange': onPlayerStateChange
                                      }
                                    });
                               }
                               
                               onYouTubePlayerAPIReady();

                            } else if (currentSlide.hasClass('slide-video')) {
                               video = currentSlide.find("video").get(0);

                               if (video != null) {
                                 if (control === "play"){
                                   video.play();

                                   self.slick('slickPause');
                                   $(video).on('ended', function() {
                                     self.slick('slickPlay');
                                     self.slick('next');
                                   });

                                 } else {
                                   video.pause();
                                 }
                               }
                            };
                        };

                        self.on('init', function(slick) {
                            slick = $(slick.currentTarget);

                            setTimeout(function(){
                                playPauseVideo(slick,"play");
                            }, 1000);
                        });

                        self.on("beforeChange", function(event, slick) {
                            slick = $(slick.$slider);
                            playPauseVideo(slick,"pause");

                            self.on("mouseenter focus", function (event, slick) {
                                $('.home-slideshow .slideshow').addClass('over_hover');
                            });
                        });

                        self.on("afterChange", function(event, slick) {
                            $('.item.slick-slide:not(.slick-current) .fluid-width-video-wrapper .video').css('display', 'none');
                            $('.slick-current .fluid-width-video-wrapper .video').css('display', 'block');
                            slick = $(slick.$slider);
                            playPauseVideo(slick,"play");
                            // if( $("video").prop('muted') ) {
                            //     $("video").prop('muted', true);
                            // } else {
                            //     $("video").prop('muted', true);
                            // }
                        });
                    };

                    {
                        if (self.data('dots') == 'none') {
                          var dots = false;
                        } else {
                          var dots = true;
                        }
                        if (self.data('dots') == 'number') {
                          var arrowsMobile = true;
                          var customPaging = (self, i) => {let index = i + 1;var count = self.slideCount;return '<a class="dot" aria-label="'+index+'/'+count+'">'+index+'/'+count+'</a>';}
                        } else {
                          var arrowsMobile = false;
                        }
                        self.slick({
                            dots: dots,
                            slidesToScroll: 1,
                            verticalSwiping: false,
                            fade: self.data('fade'),
                            cssEase: "ease",
                            adaptiveHeight: true,
                            autoplay: self.data('autoplay'),
                            autoplaySpeed: self.data('autoplay-speed'),
                            arrows: self.data('arrows'),
                            nextArrow: window.arrows.icon_next,
                            prevArrow: window.arrows.icon_prev,
                            customPaging: customPaging,
                            rtl: window.rtl_slick,
                            speed: self.data('speed') || 500,
                            responsive: [{
                                breakpoint: 1280,
                                settings: {
                                    arrows: arrowsMobile,
                                    customPaging: customPaging,
                                    dots: true
                                }
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                    arrows: arrowsMobile,
                                    customPaging: customPaging,
                                    dots: true
                                }
                            }
                            ]
                        });
                    };
                });
            };
        }
  }
  halo.initSlideshow();

  // Theme editor: this file runs once per page, so a slideshow whose section
  // is re-rendered (a slide added, removed or edited) would otherwise stay
  // un-initialised and show only its first slide.
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      halo.initSlideshow(event.target);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      $(event.target).find('.slick-initialized[data-init-slideshow]').slick('unslick');
    });
    // Selecting a slide in the sidebar shows it and holds it until deselected.
    var sliderOfBlock = function (event) {
      var slide = $('#block-' + event.detail.blockId).closest('.slick-slide');
      return { slide: slide, slider: slide.closest('.slick-initialized[data-init-slideshow]') };
    };
    document.addEventListener('shopify:block:select', function (event) {
      var found = sliderOfBlock(event);
      if (!found.slider.length) return;
      found.slider.slick('slickPause').slick('slickGoTo', parseInt(found.slide.attr('data-slick-index'), 10));
    });
    document.addEventListener('shopify:block:deselect', function (event) {
      var found = sliderOfBlock(event);
      if (found.slider.length && found.slider.data('autoplay')) found.slider.slick('slickPlay');
    });
  }

  if ($('body').hasClass('cursor-fixed__show')){
    window.sharedFunctionsAnimation.onEnterButton();
    window.sharedFunctionsAnimation.onLeaveButton();
  }
})(jQuery);
